export default "__VITE_ASSET__599mF9Rp__"